import React, { useEffect } from 'react';
import { useStore } from '../lib/store';
import { userProfileService } from '../lib/pharmacyServices';
import { authService } from '../lib/auth';
import LoginPage from '../pages/Login';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { user, userProfile, loading, setUser, setUserProfile, setLoading } = useStore();

  useEffect(() => {
    authService.getCurrentUser().then(async (user) => {
      setUser(user);
      if (user) {
        try {
          const profile = await userProfileService.getProfile(user.id);
          if (!profile) {
            const newProfile = await userProfileService.createProfile(user.id, 'admin');
            setUserProfile(newProfile);
          } else {
            setUserProfile(profile);
          }
        } catch (error) {
          console.error('Failed to load user profile:', error);
        }
      }
      setLoading(false);
    });

    const { data: { subscription } } = authService.onAuthStateChange(async (user) => {
      setUser(user);
      if (user) {
        try {
          const profile = await userProfileService.getProfile(user.id);
          setUserProfile(profile);
        } catch (error) {
          console.error('Failed to load user profile:', error);
          setUserProfile(null);
        }
      } else {
        setUserProfile(null);
      }
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, [setUser, setUserProfile, setLoading]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <>{children}</>;
};

export default AuthGuard;
